<template>
  <div>
    ANALYTIC
    <hr>
    <b-form-group :class="{'error-input' : $v.data_analytic.title.$error}">
      <label> Analytic Title </label>
      <j-input
        v-model="$v.data_analytic.title.$model"
        :max-length="255"
        placeholder="Analytic Title"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_analytic.analytic.$error}">
      <label> Analytic URL </label>
      <j-input
        v-model="$v.data_analytic.analytic.$model"
        placeholder="Analytic URL"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeAnalytic">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveAnalytic">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_analytic: {
      title: {
        required,
      },
      analytic: {
        required,
      },
    },
  },
  data() {
    return {
      data_analytic: {
        title: '',
        analytic: '',
      },
    };
  },
  computed: {
    generateDataAnalytic() {
      const data = {
        value_id: '0',
        widget_master_id: this.dataMaster.id,
        info: JSON.stringify({
          url: this.data_analytic.analytic,
          name: this.data_analytic.title,
        }),

        type: 3,
        position: this.dataMaster.position,
      };
      return data;
    },

    generateDataAnalyticUpdate() {
      const data = {

        widget_master_id: this.dataMaster.id,
        info: JSON.stringify({
          url: this.data_analytic.analytic,
          name: this.data_analytic.title,
        }),

        type: 3,
        position: this.dataMaster.position,
        order: this.dataEdit.order,
      };
      return data;
    },
  },
  mounted() {
    if (this.modeEdit) {
      this.data_analytic.title = JSON.parse(this.dataEdit.info).name;
      this.data_analytic.analytic = JSON.parse(this.dataEdit.info).url;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveWidget', 'updateWidget']),

    saveAnalytic() {
      this.$v.data_analytic.$touch();
      if (!this.$v.data_analytic.$error) {
        if (!this.modeEdit) {
          const dataParam = this.generateDataAnalytic;
          this.saveWidget(dataParam);
        } else {
          const widgetId = this.dataEdit.id;
          const dataParam = this.generateDataAnalyticUpdate;
          this.updateWidget({ widgetId, dataParam });
        }

        this.closeAnalytic();
      }
    },

    closeAnalytic() {
      this.$emit('close-field');
      this.data_analytic.title = '';
      this.data_analytic.analytic = '';
      setTimeout(() => {
        this.$v.data_analytic.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/widget/widget-component/jAnalytic2Setup.vue